import { SortDirection } from '@angular/material/sort';
import { Entity, Nullable } from '@pin-up-global/common';
import { BotUser } from '@shared/bot-user';
import { FeedbackStatus } from '@root/pages/feedback';

export enum FeedbackAuthor {
  Bot = 'bot',
  User = 'user',
}

export enum FeedbacksTableRowActions {
  Open = 'open',
  Archive = 'archive',
}

export type FeedbackBotUser = Pick<BotUser, 'id' | 'firstName' | 'lastName'>;

export interface FeedbacksReq {
  botId: number;
  botUserId?: number;
  status?: Nullable<FeedbackStatus>; 
  receivedAtStart?: Nullable<string>;
  receivedAtEnd?: Nullable<string>;
  deleted?: boolean;
  page?: number;
  search?: Nullable<string>;
  limit?: number;
  sort?: string;
  sortType?: SortDirection;
}

export interface FeedbackRow extends Entity {
  botId: number;
  status: FeedbackStatus;
  receivedAt: string;
  botUser: FeedbackBotUser;
  fullName?: string;
}

export interface FeedbackStatusOption {
    value: Nullable<FeedbackStatus>;
    label: string;
}
